import React, {FC, useState, useEffect} from "react";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { StartPage } from "../../../components";
import { billingService } from "../../../api";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../utils/display-price";
import { usePageTitle } from "../../../context/navigationContext";

const ConfigOptions:FC = () => {
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [paginationData, setPaginationData] = useState<any>()
  const [invoices, setInvoices] = useState<any[]>([])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [t] = useTranslation()
  usePageTitle(t("PAGE_TITLE_CONFIG_OPTIONS"));
  const getInvoices = () => {
    billingService.getConfigOptions({
      page:page || 1,
      page_size:pageSize || 10,
      ordering:ordering,
      search:searchString||''
    })
    .then((res) => {
      setInvoices(res.data.objects.map((configOption:any) => {
        return {
          ...configOption,
          display_name: configOption.display_name || '-',
          internal_name: configOption.name || '-',
          status: configOption.status || '-',
          widget: configOption.widget || '-',
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      console.log('error', e);
      setPageLoading(false)
    })
  }
  useEffect(() => {
    getInvoices()
    const interval = setInterval(() => {
      getInvoices()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString])
  const ColumnsInvoices = [
    {
      title:t("DISPLAY_NAME"),
      key:'display_name',
      sorted:true,
    },
    {
      title:t("INTERNAL_NAME"),
      key:'internal_name',
      sorted:true,
    },
    {
      title:t("STATUS"),
      key:'status',
      sorted:true,
    },
    {
      title:t("WIDGET"),
      key:'widget',
      sorted:true,
    },
  ]
  
  return (
    <>
      <StartPage
        title={`${t("CONFIG_OPTIONS")}`}
        noResourceText={`${t("NO_CONFIG_OPTIONS")}`}
        haveResource={invoices.length > 0}
        pageLoading={pageLoading}
        tableData={{
          columns:ColumnsInvoices,
          data:invoices,
          hideCheckbox:true,
          paginationData:paginationData,
          updateData:getInvoices
        }}
      />
    </>
  )
}

export default ConfigOptions
